import { HomePageConstants } from '../../../_constants';

const initialState = { addOrgLoading: true, data: '', error: false };

export function addOrgReducer(state = initialState, action) {

    switch (action.type) {
        case HomePageConstants.REQUEST_ADD_ORG:
            return {
                addOrgLoading: true,
                data: '',
                error: false
            };
        case HomePageConstants.RECEIVE_ADD_ORG:
            return {
                addOrgLoading: false,
                data: action.addOrg,
                error: false
            };
        case HomePageConstants.ADD_ORG_ERROR:
            return {
                addOrgLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/HomePage/Organisation/addOrg.reducer.js